module.exports = __webpack_public_path__ + "img/i70-banner.287161ff.png";